/* eslint-disable no-underscore-dangle */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';
import { getCurrency } from 'models/payment';
import maskAmount from 'utils/maskAmount';
import Modal from 'components/modals/Modal';

const BidStatusModal = ({
  t, data, setData, machine, offers, user,
}) => {
  const [time, setTime] = useState(20);
  const [bidAmountInTry, setBidAmountInTry] = useState(0);

  const previousBiggestOfferAmount = useMemo(() => {
    if (!data || data.error) {
      // Bid failed
      return offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice;
    }

    // Bid successful
    return offers?.length > 1 ? offers[1].offer : machine.auctionStartPrice;
  }, [data, offers, machine]);

  const convertEurToTry = async (amountInEur) => {
    const approxValue = await getCurrency(amountInEur);
    setBidAmountInTry(approxValue);
  };

  useEffect(() => {
    convertEurToTry(data.amount);
  }, [data]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (time === 0) {
        setData({});
      }
      setTime(time - 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [time]);

  return (
    <Modal
      visible={!_.isEmpty(data)}
      setVisible={() => setData({})}
    >
      <div className="modal-content modal-transparent">
        <div className="modal-body p-0">
          <div className="im-box im-box--white im-box--border-radius im-box--padding-sm-15">

            <div className="row align-items-center">
              <div className="col-15 col-sm-8">
                <div className="row">
                  <div className="col-15 col-sm-5 mb-4 mb-sm-0">
                    {
                      machine?.report.images.length > 0
                        ? (
                          <Image
                            src={machine.report.images[0].main}
                            layout="responsive"
                            width="800"
                            height="800"
                            className="img-responsive"
                          />
                        )
                        : (
                          <Image
                            src="/image/machine-detail-slider-placeholder.jpg"
                            layout="responsive"
                            width="800"
                            height="800"
                            className="img-responsive"
                          />
                        )
                    }
                  </div>
                  <div className="col-15 col-sm-10 mb-4 mb-sm-0">
                    <div className="mb-3">
                      <div className="fs-15 fw-900">{getObjectByLanguage(machine.title)}</div>
                    </div>
                    <ul className="im-list im-list--type5">
                      <li>
                        <div className="im-list__label">{t('machineNo')}</div>
                        <div className="im-list__value">{machine.machineId}</div>
                      </li>
                      <li>
                        <div className="im-list__label">{t('locationDif')}</div>
                        <div className="im-list__value">{`${machine?.region}, ${getObjectByLanguage(machine?.country.name)}`}</div>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
              <div className="col-15 col-sm-7">
                <div className="row">
                  <div className="col">
                    <div className="text-center">
                      <div className="fs-15 fw-900 mb-2">
                        {`Önceki en yüksek teklif: ${maskAmount(previousBiggestOfferAmount)}`}
                      </div>
                      <div className={`fs-30 fw-900 mb-2 ${data.error ? 'text-red2' : 'text-green2'}`}>
                        {maskAmount(data.amount)}
                      </div>
                      <div className="fs-15">
                        Verdiğiniz Teklif
                        {' '}
                        <span className="fs-13 text-gray3 mt-1">
                          {`(${t('approx')} ${maskAmount(bidAmountInTry, 'TRY')})`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4 mb-4">
              <div className="col">
                <div className="separator separator--horizontal" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="row mb-5">
                  <div className="col text-center">
                    {
                      data.error
                        ? (
                          <div className="sign sign--error">
                            <i className="fa-solid fa-exclamation" />
                          </div>
                        )
                        : (
                          <div className="sign sign--success">
                            <i className="fa-solid fa-exclamation" />
                          </div>
                        )
                    }
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col text-center">
                    <div className="fs-22 fw-700">{data.error ? 'Teklifiniz Onaylanmadı!' : t('youAreTheHighestBidder')}</div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col text-center">
                    <p className="fs-15">
                      {
                        data.error
                          ? data.error.message
                          : 'Verilen teklifler, teklif verenin sorumluluğundadır ve bağlayıcıdır. Teklifiniz, açık artırmayı kazanan teklif olduğu takdirde makinayı satın almayı kabul etmiş olursunuz.'
                      }
                    </p>
                  </div>
                </div>
                <div className="row mt-5 mb-3">
                  <div className="col text-center">
                    {
                      !data.error
                        && (
                          <span className="fs-14 text-gray10 mb-1">
                            Teklif limitiniz
                            {' '}
                            <b>{maskAmount(user.userBuyingLimit, 'EUR')}</b>
                            'dir. Teklifinizle ilgili her türlü soru sormak, bilgi almak ya da teklif limitinizi artırmak
                            için
                            {' '}
                            <b>+90 (850) 885 46 25</b>
                            {' '}
                            irtibat numarasından bize ulaşabilirsiniz.
                          </span>
                        )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-2">
            <div className="col text-center">
              <div className="fs-15 text-white">{`Bu sayfa ${time < 10 ? `0${time}` : time} saniye içinde kapanacaktır.`}</div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

BidStatusModal.propTypes = {
  t: PropTypes.func,
  data: PropTypes.object,
  setData: PropTypes.func,
  machine: PropTypes.object,
  offers: PropTypes.array,
  user: PropTypes.object,
};

export default withTranslation('common')(BidStatusModal);
